(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (App, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, Hotjar, LocalStorage, CustomDimension, Constantes, $) {
  'use strict';

  // ==================================================
  // Manejador de eventos step
  // ==================================================  

  Handler.setOrigin = function () {
    if (Config.ingresarPrefix.test(window.location.pathname)) {
      Model.updateAccesoWindowModel();
    } else if (Config.cambiarClavePrefix.test(window.location.pathname)) {
      Model.updateCambioClaveWindowModel();
      Model.updateCambioClaveUsuarioModel();
    }
  }

  Handler.router = function () {
    Handler.setOrigin();
    var modo = Model.Window.modo;
    Helper.setupPrevious();
    switch (modo) {
      case 'C':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.reestablecerPasswordCodigoLoad();
          Helper.resizeHandler();
          Helper.placeHolder();
        })
        break;
      case 'V':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.validarCredencialBlack();
          Helper.resizeHandler();
          Helper.placeHolder();
        })
        break;
      case 'A':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.validarTipoAsociacionClub();
          Helper.resizeHandler();
          Helper.placeHolder();
        })
        break;
      case 'S':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView();
          Helper.resizeHandler();
          Helper.placeHolder();
          /* Funcion automatica que retorna al origen si detecto que esta logueado*/
          Service.ifLoggedReturnBack();
        })
        break;
      case 'P':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView();
          Helper.resizeHandler();
          Helper.placeHolder();
          Hotjar.callTrigger(Config.HotjarHeatmapLogin);
        })
        break;
      case 'CLA':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView("", Service.ifLoggedNextStep);
          Helper.resizeHandler();
          Helper.placeHolder();
        })
        break;
      default:
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView();
          Helper.resizeHandler();
          Helper.placeHolder();
        })
    }
  }

  // ==================================================
  // Manejador de eventos step
  // ==================================================  
  Handler.stepHandler = function (step, obj) {
    switch (step) {
      case 'inicio':
        Controller.inicioView();
        break;
      case 'acceder_nativo':
        Controller.accederNativo();
        break;
      case 'acceder_facebook':
        Controller.accederFacebook();
        break;
      case 'acceder_gmail':
        Controller.accederGmail();
        break;
      case 'asociar_gmail':
        Controller.asociarGmail();
        break;
      case 'asociar_facebook':
        Controller.asociarFacebook();
        break;
      case 'porque_redsocial':
        Controller.accederRedSocialView();
        break;
      case 'acceder_nativo_ingresar_password':
        Controller.accederNativoIngresarPassword();
        break;
      case 'crear_cuenta_nativo':
        Analytics.crearCuentaNativoClick();
        Controller.crearCuentaNativo();
        break;
      case 'crear_cuenta_nativo_view':
        //Aca                
        Controller.crearCuentaNativoView(true);
        break;
      case 'crear_cuenta_directo':
        Controller.crearCuentaDirecta();
        break;
      case 'crear_cuenta_directo_view':
        Analytics.crearCuentaNativoLink();
        Controller.crearCuentaDirectaView();
        break;
      case 'crear_cuenta_datos':
        Controller.crearCuentaDatos();
        break;
      case 'crear_cuenta_datos_view':
        Controller.crearCuentaDatosView(Helper.getCurrentStep() == 'crear_cuenta_nativo');
        break;
      case 'crear_cuenta_password':
        Controller.crearCuentaPassword();
        break;
      case 'crear_cuenta_password_view':
        Controller.crearCuentaPasswordView();
        break;
      case 'crear_cuenta_validar_codigo':
        Controller.crearCuentaValidarCodigo();
        break;
      case 'crear_cuenta_reenviar_codigo':
        Controller.crearCuentaReenviarCodigo();
        break;
      case 'crear_cuenta_red_social':
        Controller.crearCuentaRedSocial();
        break;
      case 'reestablecer_password':
        Controller.reestablecerPassword();
        break;
      case 'reestablecer_password_procesar':
        Controller.reestablecerPasswordProcesar();
        break;
      case 'reestablecer_password_codigo':
        Controller.reestablecerPasswordCodigo();
        break;
      case 'reestablecer_password_expirado_codigo':
        Controller.reestablecerPasswordExpiradoCodigo();
        break;
      case 'reestablecer_password_expirado':
        Controller.reestablecerPasswordExpiradoView();
        break;
      case 'logout-facebook':
        Service.logoutFacebook();
        break;
      case 'logout-gmail':
        Service.logoutGmail();
        break;
      case 'volver_a_ingresar':
        App.reload();
        break;
      case 'retornar_acceder':
        Controller.retornarAcceder();
        break;
      case 'volver_a_origen':
        Helper.returnBack()
        break;
      case 'volver':
        Helper.returnBack({
          url: document.referrer || Constantes.Sitios[Model.Usuario.SitioId]
        });
        break;
      case 'asociar_tarjeta_corto':
        Controller.asociarCredencialCorto();                // Asociar corto
        break;
      case 'asociar_tarjeta_largo':
        Controller.asociarCredencialLargo();                // Asociar largo
        break;
      case 'validar_tipo_asociacion_club':
        Controller.validarTipoAsociacionClub();
        break;
      default:
    }
  }


  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.loginResponseHandler = function (obj, status, xhr, isSmartlock) {
    console.log('LoginHandler | ' + obj.code);

    isSmartlock = isSmartlock || false;
    var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(obj.response, [1]);
    var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(obj.response, [2]);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.deleteAllCookies();
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();

        // Si esta cargada la Password (vino por nativo), ejecuto el store nativo.
        if (Model.Usuario.Clave)
          Service.storeNativo(Model.Usuario);
        break;
      case '0003':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('CREAR_CUENTA_RED_SOCIAL');
        break;
      //Alta red social OK
      case '0010':
        Model.Usuario.IsNewUser = true;
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Asociacion OK
      case '0020':
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        Service.smartlockSignOut();
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        var message = Message.Usuario['USUARIO_NO_EXISTE'];
        Service.mostrarError(message, Message.Analytis.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Usuario o contraseña inválidos. Por favor, ingresalos nuevamente. (No se le pasa Contraseña)                
      case '0120':
        if (isSmartlock) {
          Service.smartlockSignOut();
          Service.mostrarError(Message.Usuario['CLAVE_FAIL'], Message.Analytics.Usuario['CLAVE_FAIL'], {
            'text': Message.Usuario['VOLVER_A_INTENTARLO'],
            'stepBack': 'volver_a_ingresar'
          });
        } else {
          $('.atencion').hide(); //Oculto los mensajes de aviso
          $('#aviso-mensaje').show();
          if (obj.response) {
            Model.Usuario.NeedRecaptchaValidation = true;
            if (Helper.Recaptcha.isSubmitted()) {
              Helper.Recaptcha.reset();
            } else {
              Helper.Recaptcha.render('acceder_nativo_ingresar_password_recaptcha');
            }
            $('#captcha-validation').show();
          }
          Helper.changeStatus($('#acceder_nativo_username'), true, null);
          Helper.changeStatus($('#acceder_nativo_password'), true, null);
          Helper.cleanInputs();
        }
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;
      //Usuario o contraseña inválidos. Por favor, ingresá con tu cuenta de red social. (Existe usuario pero o tiene SHA1)
      case '0130':
        $('#aviso-mensaje').show();
        Helper.changeStatus($('#acceder_nativo_username'), true, null);
        Helper.changeStatus($('#acceder_nativo_password'), true, null);
        Helper.cleanInputs();
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;

      /*SE DESHABILITO EL VENCIMIENTOD DE CLAVE. DE ACA PARA ABAJO NINGUN HANDLER DEBERIA EJECUTARSE NUNCA*/
      //Tu clave expiró - Logueate con tu cuenta de Facebook (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0140':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0145':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ o de Facebook (Tiene SHA1 y ambas redes  sociales pero el SHA1 está vencido)
      case '0150':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - (Default de clave expirada)
      case '0155':
        Helper.setToken(obj.message);
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      /*SE DESHABILITO EL VENCIMIENTOD DE CLAVE. HASTA ACA NINGUN HANDLER DEBERIA EJECUTARSE NUNCA*/

      //Suspendido por abuso
      case '0160':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['SUSPENDIDO_POR_ABUSO'], Message.Analytics.Usuario['SUSPENDIDO_POR_ABUSO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Eliminado Logico
      case '0170':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['ELIMINADO_LOGICO'], Message.Analytics.Usuario['ELIMINADO_LOGICO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0175':
        //
        break;
      //Suspendido definitivo
      case '0180':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['SUSPENDIDO_DEFINITIVO'], Message.Analytics.Usuario['SUSPENDIDO_DEFINITIVO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0185':
        if (isSmartlock) {
          Service.smartlockSignOut();
          Service.mostrarError(obj.message, obj.message, {
            'text': Message.Usuario['VOLVER_A_INTENTARLO'],
            'stepBack': 'volver_a_ingresar'
          });
        } else {
          Helper.changeStatus($('#acceder_nativo_password'), false, obj.message, obj.message);
          Model.Usuario.NeedRecaptchaValidation = false;
          $('#captcha-validation').hide();
        }
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;
      //El usuario no confirmó la casilla --> Token_Temporal                
      case '0190':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Controller.grabarTokenTemporal(obj, status, xhr);
        break;
      //Se controla un error que puede dar clave duplicada
      case '0195':
        logger && logger.error('Login | Alta red invalida', { Response: obj, Modelo: Model });
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['ALTA_RED_INVALIDA'], Message.Analytics.Usuario['ALTA_RED_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0282':
        Helper.cleanInputs();
        Helper.changeStatus($('#acceder_nativo_password'), false, obj.message, obj.message);
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;
      case '0001':
        logger && logger.fatal('Login | Error General', { Response: obj, Modelo: Model });
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;

      default:
        logger && logger.error('Login | No existe codigo respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.loginCrearCuentaResponseHandler = function (obj, status, xhr) {
    console.log('CuentaHandler | ' + obj.code);

    var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(obj.response, [1]);
    var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(obj.response, [2]);
    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.deleteAllCookies();
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Usuario o contraseña inválidos. Por favor, ingresalos nuevamente. (No se le pasa Contraseña)                
      case '0110':
      case '0120':
        $('.atencion').hide(); //Oculto los mensajes de aviso
        $('#aviso-mensaje').show();
        Helper.changeStatus($('#acceder_nativo_username'), true, null);
        Helper.changeStatus($('#acceder_nativo_password'), true, null);
        Helper.cleanInputs();
        break;
      //Usuario o contraseña inválidos. Por favor, ingresá con tu cuenta de red social. (Existe usuario pero o tiene SHA1)
      case '0130':
        $('#aviso-mensaje').show();
        Helper.changeStatus($('#acceder_nativo_username'), true, null);
        Helper.changeStatus($('#acceder_nativo_password'), true, null);
        Helper.cleanInputs();
        break;
      //Tu clave expiró - Logueate con tu cuenta de Facebook (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0140':
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0145':
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ o de Facebook (Tiene SHA1 y ambas redes  sociales pero el SHA1 está vencido)
      case '0150':
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - (Default de clave expirada)
      case '0155':
        Helper.setToken(obj.message);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Suspendido por abuso
      case '0160':
        Service.mostrarError(Message.Usuario['SUSPENDIDO_POR_ABUSO'], Message.Analytics.Usuario['SUSPENDIDO_POR_ABUSO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Eliminado Logico
      case '0170':
        Service.mostrarError(Message.Usuario['ELIMINADO_LOGICO'], Message.Analytics.Usuario['ELIMINADO_LOGICO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0175':
        //
        break;
      //Suspendido definitivo
      case '0180':
        Service.mostrarError(Message.Usuario['SUSPENDIDO_DEFINITIVO'], Message.Analytics.Usuario['SUSPENDIDO_DEFINITIVO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0185':
        Helper.changeStatus($('#acceder_nativo_password'), false, obj.message, obj.message);
        break;
      //El usuario no confirmó la casilla --> Token_Temporal                
      case '0190':
        Controller.grabarTokenTemporal(obj, status, xhr);
        break;
      //Se controla un error que puede dar clave duplicada
      case '0195':
        logger && logger.error('Crear Usuario (ExisteMailUsuario) | Alta red invalida', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['ALTA_RED_INVALIDA'], Message.Analytics.Usuario['ALTA_RED_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal('Crear Usuario (ExisteMailUsuario) | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('Crear Usuario (ExisteMailUsuario) | No existe el codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.asociarRedSocialResponseHandler = function (obj, status, xhr) {
    console.log('AsociarRedHandler | ' + obj.code);

    var token = xhr.getResponseHeader("X-Token");
    var xvalue = xhr.getResponseHeader("X-Value");

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Asociacion OK
      case '0020':
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //asociarRedSocialNoOk generico
      case '0025':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //Ya existe un usuario con el perfil de Facebook ingresado.
      case '0026':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //Ya existe un usuario con el perfil de Google ingresado.
      case '0027':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //Ya existe un usuario registrado con el email ingresado.
      case '0028':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //exception
      case '0001':
        logger && logger.fatal('GestionarRedSocial | Error general', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('GestionarRedSocial | No existe codigo respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.existeMailUsuarioResponseHandler = function (obj, status, xhr) {
    console.log('MailHandler | ' + obj.code);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Model.Usuario.NeedRecaptchaValidation = obj.response;
        Controller.accederNativoIngresarPasswordView();
        break;
      // Excepcion
      case '0001':
        logger && logger.fatal("ExisteMailUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      //Usuario inexistente.
      case '0110':
        // Si se quiso ingresar con un email inexistente, cargo view de crear cuenta 
        // Si se quiso ingresar con un nick, muestro mensaje de error

        if (Config.loginProvisorio && Model.Window.modo == "P")
          Controller.altaUsuarioProvisorio();
        else {
          if (Helper.Validators.email.test(Model.Usuario.UsuarioUsuario))
            Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['EMAIL_NO_EXISTE'], Message.Analytics.Usuario['EMAIL_NO_EXISTE']);
          //Controller.crearCuentaNativoView(); 
          else
            Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['USUARIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_INVALIDO']);
        }
        break;
      //usuario existe, tiene mail y no contraseña por lo cual tiene red social.
      case '0195':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['LOGUEATE_RED_SOCIAL'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL']);
        break;
      case '0196':
        handleFacilitarAccesoGoogle('acceder_nativo_username');
        break;
      case '0197':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK']);
        break;
      // Dominio no permitido
      case '0255':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['CARACTER_INVALIDO_MAIL'], Message.Analytics.Usuario['CARACTER_INVALIDO_MAIL']);
        break;
      case '0300':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['USUARIO_DOMINIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_DOMINIO_INVALIDO']);
        break;

      default:
        logger && logger.error('ExisteMailUsuario | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.existeMailUsuarioCrearCuentaResponseHandler = function (obj, status, xhr) {
    console.log('MailCuentaHandler | ' + obj.code);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Controller.crearCuentaNativoView(Message.Usuario['USUARIO_EXISTE']);
        break;
      // Excepcion
      case '0001':
        logger && logger.fatal("ExisteMailUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Usuario inexistente.
      case '0110':
        Controller.crearCuentaDatosView(true);
        break;
      //usuario existe, tiene mail y no contraseña por lo cual tiene red social.
      case '0195':
        Controller.crearCuentaNativoView(Message.Usuario['USUARIO_EXISTE']);
        break;
      case '0196':
        alert(obj.message);
        break;
      case '0197':
        alert(obj.message);
        break;
      default:
        logger && logger.error('ExisteMailUsuario | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.existeMailUsuarioCrearCuentaDirectaResponseHandler = function (obj, status, xhr) {
    console.log('MailCuentaHandler | ' + obj.code);

    var $input = $("#crear_cuenta_directa_email");

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Analytics.formError('crear_cuenta_directa_email-' + Message.Analytics.Usuario['USUARIO_EXISTE']);
        Controller.crearCuentaDirectaView(Message.Usuario['USUARIO_EXISTE']);
        break;
      // Excepcion
      case '0001':
        logger && logger.fatal("ExisteMailUsuario (Cuenta Directa)| Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Usuario inexistente.
      case '0110':
        Controller.crearCuentaDirectaPassword();
        //Controller.crearCuentaDatosView(false);
        break;
      //usuario existe, tiene mail y no contraseña por lo cual tiene red social.
      case '0195':
        Helper.changeStatus($input, false, Message.Usuario['LOGUEATE_RED_SOCIAL'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL']);
        break;
      case '0196':
        handleFacilitarAccesoGoogle('crear_cuenta_directa_email');
        break;
      case '0197':
        Helper.changeStatus($input, false, Message.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK']);
        break;
      // Dominio no permitido
      case '0255':
        Helper.changeStatus($("#crear_cuenta_directa_email"), false, Message.Usuario['CARACTER_INVALIDO_MAIL'], Message.Analytics.Usuario['CARACTER_INVALIDO_MAIL']);
        break;
      case '0300':
        Helper.changeStatus($("#crear_cuenta_directa_email"), false, Message.Usuario['USUARIO_DOMINIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_DOMINIO_INVALIDO']);
        break;
      default:
        logger && logger.error('ExisteMailUsuario (Cuenta Directa)| No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.altaUsuarioResponseHandler = function (obj, status, xhr) {
    console.log('AltaHandler | ' + obj.code);

    Helper.Recaptcha.reset();

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        var userId = obj.response;
        Model.Usuario.IsNewUser = true;

        Analytics.createAccount();
        CustomDimension.setUserId(userId);
        CustomDimension.save();
        Service.createCustomDimension();

        Controller.grabarTokenTemporal(obj, status, xhr);
        break;
      case '0004':
        Service.mostrarError(Message.Usuario['USUARIO_CAMPO_FALTANTE'], Message.Analytics.Usuario['USUARIO_CAMPO_FALTANTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      // El usuario ya existe
      case '0115':
        Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_INVALIDO'], Message.Analytics.Usuario['CAPTCHA_INVALIDO']);
        Helper.Recaptcha.reset();
        break;
      // El usuario ya existe                
      case '0210':
        Service.mostrarError(Message.Usuario['USUARIO_EXISTE_MAIL'], Message.Analytics.Usuario['USUARIO_EXISTE_MAIL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Error de captcha
      case '0215':

        break;
      //Error al enviar el email
      case '0250':
        logger && logger.error("AltaUsuario | Email envio Error", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['ALTA_MAIL_NO_ENVIO'], Message.Analytics.Usuario['ALTA_MAIL_NO_ENVIO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0260':
        Service.mostrarError(Message.Usuario['CODIGO_INVALIDO'], Message.Analytics.Usuario['CODIGO_INVALIDO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal("AltaUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;

      default:
        logger && logger.error('AltaUsuario | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  Handler.altaUsuarioProvisorioHandler = function (obj, status, xhr) {
    console.log('AltaProvisorioHandler | ' + obj.code);

    Helper.Recaptcha.reset();

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        var userId = obj.response;
        Model.Usuario.IsNewUser = true;
        Model.Usuario.Provisorio = true;
        Analytics.createAccount();
        CustomDimension.setUserId(userId);
        CustomDimension.save();
        Service.createCustomDimension();

        Handler.loginResponseHandler(obj, status, xhr);
        break;
      case '0004':
        Service.mostrarError(Message.Usuario['USUARIO_CAMPO_FALTANTE'], Message.Analytics.Usuario['USUARIO_CAMPO_FALTANTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal("AltaUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('AltaProvisorioHandler | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.obtenerDatosClubHandler = function (obj, status, xhr) {
    console.log('ObtenerHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '1':
      case '2':
        Model.Usuario.Credenciales = (obj.response !== null) ? obj.response : [];
        if (Model.Usuario.TipoAsociarCredencial == "") Model.Usuario.TipoAsociarCredencial = obj.code;
        Controller.asociarCredencialView();
        break;
      case '0001':
        logger && logger.fatal('ObtenerDatosClub | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('ObtenerDatosClub | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.validarCodigoMailLoginResponseHandler = function (object, status, xhr) {
    console.log('CodigoHandler | ' + object.code);

    //if(!code ==)
    switch (object.code) {
      // Caso de éxito.
      case '0000':
        var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(object.response, [1]);
        var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(object.response, [2]);

        Helper.deleteAllCookies();
        Helper.setToken(token);
        Helper.setXValue(xvalue);

        if ((object.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
          logger && logger.error("ValidarCodigoMailLogin | sin headers", { Response: object, Modelo: Model });
        }

        Handler.loginResponseHandler(object, status, xhr);
        break;
      case '0121':
        // Usuario o password incorrecto. Cuando crea usuario con FB.
        if (!Helper.isEmpty(Model.Usuario.UsuarioFacebookId)) {
          Model.Window.islockedFacebook = false;
          Controller.accederFacebook();
        } else if (!Helper.isEmpty(Model.Usuario.UsuarioGmailId)) {
          Model.Window.islockedGmail = false;
          Controller.accederGmail();
        }
        break;
      case '0190':
        logger && logger.error("ValidarCodigoMailLogin | Falla replicacion", { Response: object, Modelo: Model });
        Controller.crearCuentaGracias();
        break;
      // El usuario ya existe.
      case '0260':
        Controller.crearCuentaValidarCodigoView(object.message);
        break;
      case '0001':
      case '0002':
        logger && logger.fatal("ValidarCodigoMailLogin | Error General", { Response: object, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('ValidarCodigoMailLogin | No existe codigo de respuesta (' + object.code + ')', { Response: object, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.validarCodigoMailResponseHandler = function (obj, status, xhr) {
    console.log('CodigoHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.callView('CREAR_CUENTA_GRACIAS');
        break;
      // El usuario ya existe
      case '0260':
        Controller.crearCuentaValidarCodigoView(obj.message);
        break;
      case '0001':
      case '0002':
        logger && logger.fatal('validarCodigoMailResponseHandler | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('validarCodigoMailResponseHandler | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.olvidoClaveHandler = function (obj, status, xhr) {
    console.log('OlvidoHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Controller.reestablecerPasswordEnvioView();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        Helper.changeStatus($('#reestablecer_password_email'), false, Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE']);
        break;
      // El usuario ya existe
      case '0115':
        Service.mostrarErrorTrackeaForm(Message.Usuario['CAPTCHA_INVALIDO'], Message.Analytics.Usuario['CAPTCHA_INVALIDO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        Helper.Recaptcha.reset();
        break;
      // Se produjo un error al enviar el mail al nuevo usuario registrado.​
      case '0250':
        logger && logger.error('ValidarUsuarioOlvidoClaveMailRecaptcha | Error al enviar email', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_EXISTE'], Message.Analytics.Usuario['USUARIO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal('ValidarUsuarioOlvidoClaveMailRecaptcha | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;

      default:
        logger && logger.error('ValidarUsuarioOlvidoClaveMailRecaptcha | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.olvidoClaveCodigoLoadHandler = function (obj, status, xhr) {
    console.log('OlvidoLoadHandler | ' + obj.code);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Controller.reestablecerPasswordCodigoView();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        logger && logger.error('ValidarCambioContrasenia | No se le pasa usuario (0110)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0135':
        logger && logger.error('ValidarCambioContrasenia | No se le pasa usuario (0135)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0175':
        Service.mostrarError(Message.Error['ENLACE_CADUCADO'], Message.Analytics.Error['ENLACE_CADUCADO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0165':
        logger && logger.error('ValidarCambioContrasenia | No se le pasa usuario (0165)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      case '0001':
        logger && logger.fatal('ValidarCambioContrasenia | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;

      default:
        logger && logger.error('ValidarCambioContrasenia | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.olvidoClaveCodigoHandler = function (obj, status, xhr) {
    console.log('OlvidoCodigoHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0':
      case '0000':
        Helper.setToken("");
        Controller.reestablecerPasswordCodigoGraciasView();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        logger && logger.error('ActualizarClave | No se le pasa usuario (0110)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0125':
        logger && logger.error('ActualizarClave | No se pudo actualizar la contraseña', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['NO_ACTUALIZA'], Message.Analytics.Usuario['NO_ACTUALIZA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0135':
        logger && logger.error('ActualizarClave | No se le pasa usuario (0135)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0270':
        Controller.reestablecerPasswordCodigoView(obj.message);
        break;
      case '0280':
        Service.mostrarError(Message.Error['CLAVE_ACTUAL_INVALIDA'], Message.Analytics.Error['CLAVE_ACTUAL_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      case '0281':
        Service.mostrarError(Message.Error['CLAVE_ANTERIOR_INVALIDA'], Message.Analytics.Error['CLAVE_ANTERIOR_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      case '0282':
        Service.mostrarErrorTrackeaForm(Message.Usuario['CAPTCHA_INVALIDO'], Message.Analytics.Usuario['CAPTCHA_INVALIDO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        Helper.Recaptcha.reset();
        break;
      case '0305':
        Helper.changeStatus($('#reestablecer_password_codigo_password'), false, Message.Usuario['USUARIO_CLAVE_REPETIDA'], Message.Analytics.Usuario['USUARIO_CLAVE_REPETIDA']);
        Helper.Recaptcha.reset();
        //Service.mostrarError(Message.Usuario['USUARIO_CLAVE_REPETIDA'], {
        //    'text': Message.Usuario['VOLVER_A_INTENTARLO'],
        //});
        break;
      case '0001':
        logger && logger.fatal('ActualizarClave | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      default:
        logger && logger.error('ActualizarClave | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  }

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  // NO SE USA
  //Handler.asociarTarjetaResponseHandler = function (obj) {
  //    //if(!code ==)
  //    switch (obj.code) {
  //        //Caso Todo OK
  //        case '0000':
  //            //Controller.finalizarAcceder();            
  //            break;

  //        default:
  //            throw new Error("No existe el tipo de estado");
  //    }
  //}


  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.logoutHandler = function (obj, status, xhr, options) {
    console.log('LogoutHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.returnBackLogout(options);
        break;
      default:
        logger && logger.error('Logout | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        Helper.returnBackLogout(options);
    }
  }

  // ==================================================
  // Manejador de errores http
  // ================================================== 
  Handler.failHandler = function (code) {
    console.log('FallaHandler | ' + code);

    switch (code) {
      case 500:
        Service.mostrarError(Message.Error['500'], Message.Analytics.Error['500']);
        break;
      case 400:
        Service.mostrarError(Message.Error['400'], Message.Analytics.Error['400']);
        break;
      case 401:
        Service.mostrarError(Message.Error['401'], Message.Analytics.Error['401']);
        break;
      case 402:
        Service.mostrarError(Message.Error['402'], Message.Analytics.Error['402']);
        break;
      case 403:
        Service.mostrarError(Message.Error['403'], Message.Analytics.Error['403']);
        break;
      case 200:
        ///
        break;
      case 'parsererror':
        Service.mostrarError(Message.Error['PARSER_ERROR'], Message.Analytics.Error['PARSER_ERROR']);
        break;
      case 'timeout':
        Service.mostrarError(Message.Error['TIMEOUT'], Message.Analytics.Error['TIMEOUT']);
        break;
      case 'abort':
        Service.mostrarError(Message.Error['ABORT'], Message.Analytics.Error['ABORT']);
        break;
      case 0:
        break;
      default:
        logger && logger.error('FailHandler | No existe codigo de respuesta (' + code + ')', { Modelo: Model });
      //throw new Error("No existe el error");
    }
  }

  // ==================================================
  // Manejador de tipo de credencial nota Black
  // ================================================== 
  Handler.validarCredencialBlackHandler = function () {
    switch (Model.Usuario.ClubNacion) {
      case 'B':
        Helper.returnBack();                            // Credencial Black . Voy a url de callback . 
        break;
      case 'P':
      case 'C':
      case 'S':
      case 'D':
        Helper.callView('ASOCIAR_TARJETA_NO_BLACK');    // Diseño credencial no permite acceder a la nota . 
        break;
      case '':
      case '0':
        Controller.validarTipoAsociacionClub();         // No tengo credencial asignada . Pido asignar . 
        break;
      default:
        logger && logger.error('ValidarCredencialBlack | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']); // Error en Usuario/Me . 
        break;
    }
  }

  // ==================================================
  // Manejador de tipo de credencial para asociacion post-login
  // ================================================== 
  Handler.validarCredencialHandler = function () {
    switch (Model.Usuario.ClubNacion) {
      case 'B':
      case 'P':
      case 'C':
      case 'S':
      case 'D':
        Helper.returnBack();                            // Tengo credencial . Voy a url de callback . 
        break;
      case '':
      case '0':
        Controller.validarTipoAsociacionClub();         // No tengo credencial asignada . Pido asignar . 
        break;
      default:
        logger && logger.error('ValidarCredencial | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']); // Error en Usuario/Me . 
        break;
    }
  }

  Handler.asociarResponseHandler = function (obj, status, xhr) {
    console.log('AsociarHandler | ' + obj.code);

    switch (obj.code) {
      case '1':
        var usuarioDetalleClubNacion = Helper.readCookie("usuarioDetalleClubNacion");
        Analytics.asociacionExitosa(usuarioDetalleClubNacion, Model.Window.currentStep);
        Controller.finalizarAsociar();
        break;
      case '-1':
        logger && logger.error('AsociarCredencial | Error al asociar', { Response: obj, Modelo: Model });
        Controller.asociarCredencialView(Message.Credencial['ERROR_ASOCIAR'], 'error'); // Ocurrió un error al querer asociar . 
        Hotjar.callTrigger('vinculacion-default-error');
        break;
      case '-2':
        Controller.asociarCredencialView(Message.Credencial['ERROR_NO_COINCIDEN'], 'error'); // Ocurrió un error al querer asociar . 
        break;
      case '-3':
        var mensaje = Message.Credencial['ERROR_YA_ASOCIADO'];
        mensaje = mensaje.replace("{{email}}", obj.response);
        Controller.asociarCredencialView(mensaje, 'advertencia'); // Ocurrió un error al querer asociar .  
        Hotjar.callTrigger('vinculacion-ya-asociado');
        break;
      default:
        logger && logger.error('AsociarCredencial | Error al asociar', { Response: obj, Modelo: Model });
        Controller.asociarCredencialView(Message.Credencial['ERROR_ASOCIAR'], 'error'); // Ocurrió un error al querer asociar . 
        Hotjar.callTrigger('vinculacion-default-error');
    }
  }



  Handler.finalizarAccederHandler = function () {
    var newUser = Model.Usuario.IsNewUser || false;

    if (Model.Usuario.Provisorio) {
      Analytics.loginProvisorio(newUser, 'Nativo', Helper.readCookie("usuario%5Fid"));
    }
    else {
      if (!Helper.isEmpty(Model.Usuario.UsuarioFacebookId)) {
        Analytics.login(newUser, 'Facebook', Helper.readCookie("usuario%5Fid"));
      }
      else if (!Helper.isEmpty(Model.Usuario.UsuarioGmailId)) {
        Analytics.login(newUser, 'Google', Helper.readCookie("usuario%5Fid"));
      }
      else {
        Analytics.login(newUser, 'Nativo', Helper.readCookie("usuario%5Fid"));
      }
    }
    
    switch (Model.Window.modo) {
      case "B":
        Handler.validarCredencialBlackHandler();
        return;
        break;
    }

    LocalStorage.setExpiredItem(Config.LoginFlagKey, false);

    // Handler por sitioid
    // Dependiendo el sitioid, veo si dsp del login tengo que validar el asociado de credencial 
    if (Config.SitiosAsociarCredencial.indexOf(Model.Window.SitioId) != -1) {
      Handler.validarCredencialHandler();
      return;
    }

    Helper.returnBack();
  }
  /* LM */

  Handler.keypressHandler = function (object, event) {

    if (event.which !== 13) {
      Helper.checkNextButton(object);
    }

    if (event.which === 13) {
      if (Model.Window.keyPress <= Config.keyPressLimit) {
        Model.Window.keyPress++;
      } else {
        Helper.showPreloader();
        setTimeout(function () {
          Helper.cleanKeyPress();
          Helper.hidePreloader();
        }, Config.freezeTime);
      }
    }

    if (event.which === 20) {
      Helper.checkCapsLock(event);
    }
  }

  Handler.OnFaildefaultErrorMessage = function () {
    Service.mostrarError(Message.DefaultErrorMessage, Message.Analytics.DefaultErrorMessage);
  }

  function handleFacilitarAccesoGoogle(inputId) {
    //const experimentId = Constantes.FacilitarAccesoGoogleExperimentId;

    const messageKey = 'LOGUEATE_RED_SOCIAL_GOOGLE';
    //const friendlyMessage = Message.Usuario[messageKey];
    const analyticsMessage = Message.Analytics.Usuario[messageKey];

    //Helper.StartExperiment(experimentId);

    //let experiment = Model.Usuario.Experiments.filter(e => e.id === experimentId);

    //if (experiment.length > 0 && experiment[0].variation == '1') {
    Analytics.formError(`${inputId}-${analyticsMessage}`);
    Controller.facilitarAccesoGoogle();
    //}
    //else {
    //    Helper.changeStatus($(`#${inputId}`), false, friendlyMessage, analyticsMessage);
    //}
  }


})(LN.App, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, LN.Hotjar, LN.LocalStorage, LN.CustomDimension, window.config.Constantes, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/handler.js